import React__default from 'react';
import { Table as Table$1, TableHeader, Column, TableBody, Row, Cell } from 'react-aria-components';
import { Checkbox } from '../../atoms/Checkbox.js';
import './Table.scss';

// Selection checkbox component for individual rows
const RowSelectionCheckbox = ({ itemId, isDisabled }) => {
    return React__default.createElement(Checkbox, { slot: 'selection', isDisabled: isDisabled, ariaLabel: `Select ${itemId}` });
};
// Selection checkbox component for header (select all)
const HeaderSelectionCheckbox = () => {
    return React__default.createElement(Checkbox, { slot: 'selection', ariaLabel: 'Select all items' });
};
const Table = ({ columns, items, getItemId, selectionMode = 'none', selectedItems, onSelectionChange, isRowDisabled, onRowActivate, firstColumnSticky = false, lastColumnSticky = false, className, 'aria-label': ariaLabel, }) => {
    const handleSelectionChange = (keys) => {
        if (onSelectionChange) {
            onSelectionChange(keys);
        }
    };
    // Helper function to determine if a column should be sticky
    const getColumnStickyValue = (columnIndex, totalColumns) => {
        if (firstColumnSticky && columnIndex === 0) {
            return 'left';
        }
        if (lastColumnSticky && columnIndex === totalColumns - 1) {
            return 'right';
        }
        return undefined;
    };
    return (React__default.createElement("div", { "data-rev-component": 'table' },
        React__default.createElement("div", { className: 'table-scroll-container--rev' },
            React__default.createElement(Table$1, { "aria-label": ariaLabel, selectionMode: selectionMode, selectedKeys: selectedItems, onSelectionChange: handleSelectionChange, selectionBehavior: 'toggle', className: className },
                React__default.createElement(TableHeader, { className: 'table-header--rev' },
                    selectionMode !== 'none' && (React__default.createElement(Column, { className: 'table-column--rev table-column--selection--rev' },
                        React__default.createElement(HeaderSelectionCheckbox, null))),
                    columns.map((column, index) => {
                        const stickyValue = getColumnStickyValue(index, columns.length);
                        return (React__default.createElement(Column, { key: column.id, isRowHeader: index === 0, allowsSorting: column.sortable, className: 'table-column--rev', "data-rev-is-sticky": stickyValue }, column.renderHeader
                            ? column.renderHeader({
                                sortable: column.sortable,
                                sortDirection: column.sortDirection,
                                onSort: column.onSort,
                            })
                            : column.title));
                    })),
                React__default.createElement(TableBody, { className: 'table-body--rev' }, items.map((item) => {
                    const itemId = getItemId(item);
                    const isDisabled = isRowDisabled ? isRowDisabled(item) : false;
                    return (React__default.createElement(Row, { key: itemId, id: itemId, isDisabled: isDisabled, onAction: onRowActivate && (() => onRowActivate(item)), className: 'table-row--rev' },
                        selectionMode !== 'none' && (React__default.createElement(Cell, { className: 'table-cell--rev table-cell--selection--rev' },
                            React__default.createElement(RowSelectionCheckbox, { itemId: itemId, isDisabled: isDisabled }))),
                        columns.map((column, index) => {
                            const stickyValue = getColumnStickyValue(index, columns.length);
                            return (React__default.createElement(Cell, { key: `${itemId}-${column.id}`, className: 'table-cell--rev', "data-rev-is-sticky": stickyValue }, column.renderCell(item)));
                        })));
                }))))));
};

export { Table };
//# sourceMappingURL=Table.js.map
